import React from 'react';
import styles from './styles/Dictionary.module.css';
import { Search, Result } from '../src/components/dictionary';

function App() {
  return (
    <div className={styles.wrap}>
      <Search />
      <Result />
    </div>
  );
}

export default App;
